const no = {
    nav: {
      home: "Hjem",
      browse: "Utforsk bryllup",
      dashboard: "Dashbord",
      messages: "Meldinger",
      profile: "Profil",
      login: "Logg inn",
      register: "Registrer",
      logout: "Logg ut",
      admin: "Admin",
      faq: "FAQ",
      about: "Om oss",
      contact: "Kontakt",
      pricing: "Priser",
      howItWorks: "Slik fungerer det",
    },
    auth: {
      login: {
        title: "Velkommen tilbake",
        email: "E-post",
        password: "Passord",
        button: "Logg inn",
        noAccount: "Har du ikke konto?",
        register: "Registrer deg nå",
      },
      register: {
        title: "Opprett konto",
        name: "Fullt navn",
        email: "E-post",
        password: "Passord",
        role: "Jeg vil...",
        roleHost: "Arrangere bryllup",
        roleGuest: "Delta på bryllup",
        terms: "Jeg godtar vilkårene og personvernreglene",
        button: "Registrer",
        hasAccount: "Har du allerede konto?",
        login: "Logg inn nå",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Laster...",
      error: "En feil oppstod",
      success: "Suksess",
      save: "Lagre",
      cancel: "Avbryt",
      delete: "Slett",
      edit: "Rediger",
      back: "Tilbake",
      next: "Neste",
      language: "Språk",
      currency: "Valuta",
      search: "Søk",
      filter: "Filtrer",
      all: "Alle",
      none: "Ingen",
      yes: "Ja",
      no: "Nei",
    },
    footer: {
      about: "Om oss",
      privacy: "Personvern",
      terms: "Vilkår",
      contact: "Kontakt",
      copyright: "© 2024 WEDVAYA. Alle rettigheter forbeholdt.",
    },
  };

export default no;
